import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20warm%20atmospheric%20illustration%20of%20a%20cozy%20reading%20nook%20with%20manga%20books%20scattered%2C%20soft%20golden%20sunlight%20streaming%20through%20a%20window%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20artistic%20illustration%20style%2C%20dreamy%20atmosphere%2C%20abstract%20soft%20textures%2C%20no%20text&width=1600&height=900&seq=hero-bg-manga-01&orientation=landscape"
        alt="布丁漫画网 - 优质漫画阅读平台"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-black/40" />

      <div className="relative w-full max-w-[1280px] mx-auto px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-2xl">
          <span className="inline-block px-4 py-1.5 bg-primary-500/90 text-background-50 dark:text-foreground-950 text-sm font-medium rounded-full mb-6">
            每日更新 · 海量漫画 · 免费畅读
          </span>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading text-background-50 leading-tight">
            洞洞杂货铺
            <span className="block text-2xl md:text-3xl lg:text-4xl mt-2 text-background-50/90">
              漫画全集下拉式免费阅读
            </span>
          </h1>
          <p className="mt-6 text-base md:text-lg text-background-50/80 leading-relaxed max-w-xl">
            洞洞杂货铺漫画全集下拉式免费阅读就在布丁漫画网，无删减内容+流畅加载，全章节覆盖，让您轻松追完整个故事。海量优质漫画，每日更新不重样。
          </p>
          <div className="flex flex-col sm:flex-row items-start gap-3 mt-8">
            <Link
              to="/comic/dongdong-zahuopu"
              className="px-8 py-3.5 bg-primary-500 text-background-50 dark:text-foreground-950 text-base font-medium rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
            >
              <i className="ri-play-circle-line text-lg" />
              立即开始阅读
            </Link>
            <Link
              to="/category"
              className="px-8 py-3.5 bg-background-50/20 backdrop-blur-sm text-background-50 text-base font-medium rounded-full hover:bg-background-50/30 transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2 border border-background-50/30"
            >
              <i className="ri-grid-line text-lg" />
              浏览全部漫画
            </Link>
          </div>
          <div className="flex items-center gap-6 mt-10">
            <div className="flex flex-col">
              <span className="text-2xl md:text-3xl font-bold text-background-50">120+</span>
              <span className="text-xs text-background-50/70">漫画作品</span>
            </div>
            <div className="w-px h-10 bg-background-50/30" />
            <div className="flex flex-col">
              <span className="text-2xl md:text-3xl font-bold text-background-50">5000+</span>
              <span className="text-xs text-background-50/70">漫画章节</span>
            </div>
            <div className="w-px h-10 bg-background-50/30" />
            <div className="flex flex-col">
              <span className="text-2xl md:text-3xl font-bold text-background-50">99.8%</span>
              <span className="text-xs text-background-50/70">好评率</span>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-s-line text-2xl text-background-50/60" />
      </div>
    </section>
  );
}